import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    headerContent: {
      width: '100%'
    },
    header: {
      margin: '1%'
    },
    tabsRoot: {
      marginLeft: '1%',
      marginBottom: '2%'
    },
    tabs: {
      marginTop: '2%'
    }
  })
